import { BrowserRouter, Routes, Route } from 'react-router-dom';
// AppProvider is mounted by AuthProvider so AccessGate sees the same context.
import { Layout } from '@/components/Layout';
import { InstallPrompt } from '@/components/InstallPrompt';
import { Dashboard } from '@/pages/Dashboard';
import { Members } from '@/pages/Members';
import { Projects } from '@/pages/Projects';
import { Applications } from '@/pages/Applications';
import { AccessMatrix } from '@/pages/AccessMatrix';
import { AllocationMatrix } from '@/pages/AllocationMatrix';
import { AuditLog } from '@/pages/AuditLog';
import { CostCenter } from '@/pages/CostCenter';
import { Expenses } from '@/pages/Expenses';
import { Integrations } from '@/pages/Integrations';
import { MailboxesAndDLs } from '@/pages/MailboxesAndDLs';
import { MemberAccess } from '@/pages/MemberAccess';
import { Devices } from '@/pages/Devices';
import { CostAllocation } from '@/pages/CostAllocation';
import { More } from '@/pages/More';
import { Settings } from '@/pages/Settings';
import { UserAccess } from '@/pages/UserAccess';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/members" element={<Members />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/access" element={<AccessMatrix />} />
          <Route path="/user-access" element={<UserAccess />} />
          <Route path="/allocations" element={<AllocationMatrix />} />
          <Route path="/costs" element={<CostCenter />} />
          <Route path="/expenses" element={<Expenses />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/mailboxes" element={<MailboxesAndDLs />} />
          <Route path="/more" element={<More />} />
          <Route path="/audit" element={<AuditLog />} />
          <Route path="/member-access" element={<MemberAccess />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/cost-allocation" element={<CostAllocation />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
      <InstallPrompt />
    </BrowserRouter>
  );
}
